import Loadable from '@loadable/component';
// @ts-expect-error
import install from '@takeshape/redux-little-router/lib/install';
// @ts-expect-error
import normalizeHref from '@takeshape/redux-little-router/lib/util/normalize-href';
import agentRoutes from './agent/routes';
import apiExplorerRouters from './api-explorer/routes';
import apiKeysRoutes from './api-keys/routes';
import assetsRoutes from './assets/routes';
import authRoutes from './auth/routes';
import billingRoutes from './billing/routes';
import cdnRoutes from './cdn/routes';
import Redirect from './common/components/redirect';
import contentRoutes from './content/routes';
import dashboardRoutes from './dashboard/routes';
import guardrailRoutes from './guardrails/routes';
import { history } from './history';
import indexLogRoutes from './index-log/routes';
import netlifyAddonRoutes from './netlify-addon/routes';
import projectRoutes from './project/routes';
import schemaRoutes from './schema/routes';
import staticSiteRoutes from './sites/routes';
import ssoRoutes from './sso/routes';
import roleRoutes from './user-roles/routes';
import webhooksRoutes from './webhooks/routes';
import workbenchRoutes from './workbench/routes';
import workflowRoutes from './workflows/routes';

const ProjectsList = Loadable(async () => import('./project/components/project-list'));
const AddToTakeShape = Loadable(async () => import('./add-to-takeshape/components/add-to-takeshape'));
const ChangeLog = Loadable(async () => import('./changelog/components/changelog-container'));

export const routes = {
  ...authRoutes,
  ...netlifyAddonRoutes,
  ...ssoRoutes,
  '/add-to-takeshape': {
    components: { main: Redirect },
    from: /\/add-to-takeshape/,
    to: '/add-pattern'
  },
  '/add-pattern': {
    components: { main: AddToTakeShape }
  },
  '/project/:projectId': {
    ...projectRoutes,
    ...apiKeysRoutes,
    ...cdnRoutes,
    ...webhooksRoutes,
    ...roleRoutes,
    ...billingRoutes,
    components: { main: Redirect },
    from: /\/?$/,
    to: '/branch/production'
  },
  '/project/:projectId/branch/:branch': {
    ...dashboardRoutes,
    ...assetsRoutes,
    ...contentRoutes,
    ...staticSiteRoutes,
    ...apiExplorerRouters,
    ...indexLogRoutes,
    ...workflowRoutes,
    ...guardrailRoutes,
    ...schemaRoutes,
    ...workbenchRoutes,
    ...agentRoutes
  },
  '/project/:projectId/branch': {
    components: { main: Redirect },
    from: /\/?$/,
    to: '/production'
  },
  '/projects': {
    components: { main: ProjectsList },
    '/:projectId*': {
      components: { main: Redirect },
      from: /^\/projects\//,
      to: '/project/'
    }
  },
  '/changelog': {
    components: { main: ChangeLog }
  }
};

const { pathname, search } = window.location;
const location = normalizeHref({ pathname, search });

export default install({ routes, history, location });
